<html>
    <head>
        <title>CCDATOS | Olvidó contraseña</title>
    </head>
    <body>
        <h1 class="title">Recuperar cuenta</h1>
        <mat-card>
            <mat-card-header>
                <mat-card-title class="text">Ayuda con contraseña</mat-card-title>
                <mat-card-content style="padding: 15px 0px 25px 0px;">Introduzca la dirección de correo electrónico asociada con su cuenta de DataBeer.</mat-card-content>
            </mat-card-header>

            <mat-card-content>
                <form [formGroup]="signin">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Email</mat-label>
                        <input matInput 
                            placeholder="nombre@ejemplo.com" 
                            formControlName="email"
                            autocomplete="email"
                            required>
                        <mat-icon matPrefix>person</mat-icon>
                        <mat-error *ngIf="emailError.invalid">{{getErrorMessageEmail()}}</mat-error>
                    </mat-form-field>

                    <div class="error-container">
                        <div *ngIf= errorVisible class="error-message">
                            {{ errorMessage }}
                        </div>
                    </div>
                    <button mat-raised-button class="login-btn" type="submit" (click)="continuar()">Continuar</button>
                </form>
            </mat-card-content>
        </mat-card>
    </body>
</html>
